import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useMatchMedia } from "@perxis-auto/shared/lib/lib/screens/hooks/useMatchMedia";
import { BreakPointsEnum } from "@perxis-auto/shared/lib/types/screens/breakPoints";
import "react-router";
import "@perxis-auto/shared";
import { APP } from "../../../shared/config/app.js";
import "../../../shared/config/env.js";
import "../../../shared/config/events.js";
import "redux";
import { useAppDispatch } from "../../../shared/lib/store/hooks/useAppDispatch.js";
import { useAppSelector } from "../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../shared/lib/store/hooks/useAppStore.js";
import { selectors } from "../../../features/comparison/model/index.js";
import "../../../shared/lib/store/createAppApi.js";
import "../../../shared/lib/store/createAppAsyncThunk.js";
import "../../../shared/lib/store/createAppSelector.js";
import "../../../shared/lib/store/createAppSlice.js";
import "../../../entities/vehicle/api/api.js";
import "../../../entities/vehicle/model/selectors/selectVehicleParameters.js";
import "react-redux";
import "../../../features/benefitChoice/model/index.js";
import "../../../shared/store/config/middleware/index.js";
import "../../../shared/store/config/model/selectors/selectBenefits.js";
import "../../../shared/store/config/model/selectors/selectBooking.js";
import "../../../shared/store/config/model/selectors/selectCredit.js";
import "../../../shared/store/config/model/selectors/selectFilterGrid.js";
import "../../../shared/store/config/model/selectors/selectFilterGridItems.js";
import { selectFilters } from "../../../shared/store/config/model/selectors/selectFilters.js";
import "../../../shared/store/config/model/selectors/selectGeolocator.js";
import "../../../shared/store/config/model/selectors/selectLocationCollectionIds.js";
import "../../../shared/store/config/model/selectors/selectMaps.js";
import "../../../shared/store/config/model/selectors/selectModels.js";
import "../../../shared/store/config/model/selectors/selectSort.js";
import "../../../shared/store/config/model/selectors/selectTags.js";
import "../../../shared/store/config/model/selectors/selectTradeIn.js";
import "../../../shared/store/config/model/slice.js";
import "../../../features/filterValues/api/api.js";
import "../../../features/filterValues/model/middleware/index.js";
import "../../../features/filterValues/model/selectors/selectAllFilterValues.js";
import "../../../features/filterValues/model/selectors/selectAllFilterValuesParameters.js";
import "../../../features/filterValues/model/selectors/selectAvailableFilterValues.js";
import "../../../features/filterValues/model/selectors/selectAvailableFilterValuesParameters.js";
import "../../../features/filterValues/model/selectors/selectAvailableFilterValuesQueries.js";
import "../../../features/filterValues/model/selectors/selectDependentFilterKeysByKey.js";
import "../../../features/filterValues/model/selectors/selectFilterImmutableQueries.js";
import "../../../features/filterValues/model/selectors/selectFilterImmutableValues.js";
import "../../../features/filterValues/model/selectors/selectFilterItemByKey.js";
import "../../../features/filterValues/model/selectors/selectFilterItems.js";
import "../../../features/filterValues/model/selectors/selectFilterValuesFields.js";
import "../../../features/filterValues/model/selectors/selectGroupedFilterItemByKey.js";
import { selectIsFilterValuesMissing } from "../../../features/filterValues/model/selectors/selectIsFilterValuesMissing.js";
import "../../../shared/store/installation/model/slice.js";
import "../../../shared/store/installation/middleware/index.js";
import "../../../entities/vehicle/model/selectors/selectIsVehiclesDataMissing.js";
import "../../../entities/vehicle/model/selectors/selectVehicle.js";
import "../../../entities/vehicle/model/selectors/selectVehicles.js";
import "../../../entities/vehicle/model/selectors/selectVehiclesCount.js";
import "../../../entities/vehicle/model/selectors/selectVehiclesParameters.js";
import "../../../entities/vehicle/model/selectors/selectVehiclesTotalPages.js";
import { selectors as selectors$1 } from "../../../features/favorite/model/index.js";
import "../../../features/favorite/model/slice.js";
import "../../../shared/store/pagination/model/slice.js";
import "../../../features/filterChoice/model/middleware/index.js";
import "../../../features/filterChoice/model/selectors/selectFilterHistory.js";
import "../../../features/filterChoice/model/selectors/selectFilterSortValue.js";
import "../../../features/filterChoice/model/selectors/selectFilterValuesCount.js";
import { selectIsFilterPanelVisible } from "../../../features/filterChoice/model/selectors/selectIsFilterPanelVisible.js";
import "../../../features/filterChoice/model/selectors/selectIsFilterValuesSelected.js";
import "../../../features/filterChoice/model/selectors/selectIsInitialSortValuesSelected.js";
import "../../../features/filterChoice/model/selectors/selectIsValidSortValuesSelected.js";
import "../../../features/filterChoice/model/selectors/selectSlugedFilterValues.js";
import { actions } from "../../../features/filterChoice/model/slice.js";
import "@perxis-auto/shared/lib";
import { useMergedConstructorItemProps } from "../../../shared/lib/constructor/hooks/useMergedConstructorItemProps.js";
import "../../../shared/lib/constructor/mergeConstructor.js";
import "react/jsx-runtime";
import "@perxis-auto/ui-kit";
import { useAppNavigate } from "../../../shared/lib/router/hooks/useAppNavigate.js";
import "@perxis-auto/shared/lib/lib/is/isObject";
import { GET_DEFAULT_CONTAINER_PROPS } from "../config/props.js";
const useContainer = (item) => {
  const { redirects, ...props } = useMergedConstructorItemProps(item, GET_DEFAULT_CONTAINER_PROPS);
  const { t } = useTranslation(APP.name);
  const dispatch = useAppDispatch();
  const navigate = useAppNavigate();
  const isMobile = useMatchMedia(BreakPointsEnum.smMax);
  const isFilterPanelVisible = useAppSelector(selectIsFilterPanelVisible);
  const { enable: isFiltersEnable } = useAppSelector(selectFilters);
  const isFilterValuesMissing = useAppSelector(selectIsFilterValuesMissing);
  const totalCompared = useAppSelector((state) => selectors.selectTotal(state.comparison));
  const totalFavorites = useAppSelector((state) => selectors$1.selectTotal(state.favorite));
  const isFilterPanelHidden = props.isFilterPanelHidden || !isFiltersEnable || isFilterValuesMissing;
  const onFilterPanelToggle = useCallback(() => {
    dispatch(actions.setIsVisible(!isFilterPanelVisible));
  }, [dispatch, isFilterPanelVisible]);
  const onFavoriteClick = useCallback(() => {
    navigate(redirects.onFavoriteClick.to, redirects.onFavoriteClick.options);
  }, [navigate, redirects.onFavoriteClick.options, redirects.onFavoriteClick.to]);
  const onComparisonClick = useCallback(() => {
    navigate(redirects.onComparisonClick.to, redirects.onComparisonClick.options);
  }, [navigate, redirects.onComparisonClick.options, redirects.onComparisonClick.to]);
  return {
    ...props,
    isMobile: !!isMobile,
    isFilterPanelHidden,
    isFilterPanelVisible,
    totalCompared,
    totalFavorites,
    onFilterPanelToggle,
    onComparisonClick,
    onFavoriteClick,
    t
  };
};
export {
  useContainer
};
